import { FormProvider } from 'react-hook-form';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ControllerWrapper } from '@Hooks/index.ts';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '../fields.types';
import { useWhatDoYouSellLogic } from './useWhatDoYouSellLogic';

export const WhatDoYouSell = () => {
  const { formMethods, handleSubmit } = useWhatDoYouSellLogic();
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('embedded.a.question')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'
        handleSubmit={handleSubmit}
        text={t('embedded.a.content')}>
        <ControllerWrapper
          name={EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL}
          control={formMethods.control}>
          {({ value, onChange, error, onBlur }) => (
            <LiliTextArea
              id={EddEmbeddedFields.EDD_EMBEDDED_WHAT_DO_YOU_SELL}
              value={value}
              onValueChange={(val) => onChange(val)}
              errorMsg={error?.message}
              externalErrorMessage={error?.message}
              maxLength={300}
              minHeight='min-h-[174px]'
              onBlur={onBlur}
              placeholder={t('embedded.a.placeholder')}
            />
          )}
        </ControllerWrapper>
      </StepPageWrapper>
    </FormProvider>
  );
};
